module.exports = __webpack_public_path__ + "img/e_2_8_g.7262e617.png";